module.exports = __webpack_public_path__ + "static/media/3_l_furgon_16.04_75.28.a156ba09.png";